require('../styles/menu.scss');

import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import actions from '../actions/episodeActions';
import store from '../store';




class MenuComponent extends React.Component {


  constructor(props) {
    super(props);
    this._current = 0;
    window.MenuInstance = this; // hack
    //window.addEventListener("load",()=>this.componentDidMount())
  }

  clicked(index) {
    store.dispatch(actions.EPISODE_UPDATE_CURRENT(index));
  }

  render() {
    var rows = [], i = 0, len = this.props.length;
    this.updateMenu();
    while (++i <= len) rows.push({ id: i });
    return (
      <nav className="menu" >
        <Link to={'/'} onClick={this.clicked.bind(this, window.STATE_FROM_SERVER.episodes.currentEpisodeId)} activeClassName="active" className="logo" >Home</Link>
        <ul className="saisonNav">
          <li><button className="btnSaison1" onClick={() => this.showSaisonMenu(1)} key="saison1">Saison 1</button></li>
          <li><button className="btnSaison2" onClick={() => this.showSaisonMenu(2)} key="saison2">Saison 2</button></li>
        </ul>
        <div className="episodesGroup">
          Épisodes:
          {this.createEpisodeList(rows, 1)}
          {this.createEpisodeList(rows, 2)}
        </div>
      </nav>
    );
  }

  updateMenu(){
    this.showSaisonMenu(Math.ceil(this.props.currentEpisodeId / 10))
  }

  componentDidMount() {
    this.updateMenu();
  }

  showSaisonByEpisode(ep) {
    this.showSaisonMenu(Math.ceil(ep / 10))
  }

  showSaisonMenu(saison) {
    if (this._current == saison || !document.querySelector(".episodesGroup .saison" + saison)) return;
    document.querySelector(".episodesGroup .saison" + saison).style.display = "inline-block";
    document.querySelector(".saisonNav .btnSaison" + saison).classList.add("active")
    if (this._current == 0) this._current = saison % 2 + 1
    document.querySelector(".episodesGroup .saison" + this._current).style.display = "none";
    document.querySelector(".saisonNav .btnSaison" + this._current).classList.remove("active")

    this._current = saison;
  }

  createEpisodeList(rows, saison) {
    return <ul className={"episodesNav saison" + saison}>
      {rows.slice(10 * (saison - 1), 10 * saison).map((ep) => {
        var style;
        if (ep.id === this.props.currentEpisodeId) {
          style = 'active';
        }
        return <li className={style} key={ep.id} ><Link to={'/episode/' + ep.id} activeClassName="active" onClick={this.clicked.bind(this, ep.id)} >{ep.id}</Link></li>;
      })}
    </ul>
  }
}

MenuComponent.defaultProps = {
  active: 0,
  currentEpisodeId: 1,
  length: 11
};

const mapStateToProps = function (store) {
  return {
    active: store.episodes.currentEpisodeId,
    currentEpisodeId: store.episodes.currentEpisodeId,
    length: store.episodes.total
  }
}

export default connect(mapStateToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/Menu.js